export default __webpack_public_path__ + "static/media/BG-website.dd952b2b.png";